import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import IconButton from "@mui/material/IconButton";
import { visuallyHidden } from "@mui/utils";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Dialog, TextField, useMediaQuery } from "@mui/material";
import { Order, stableSort, getComparator } from "../ui/Tables";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { TipologiaUso } from "./TipologiaUso";
import { uiStore } from "../uiStore";
import DeleteIcon from "@mui/icons-material/Delete";
import { DeleteTipologiaUso } from "./DeleteTipologiaUso";

interface Data {
  id: number;
  ClubId: number;
  descrizioneUso: string;
  Risorse_TipologieId: number;
  minPartecipanti: number;
  maxPartecipanti: number;
  note: string;
  deleted: string;
  sigla: string;
  coloriId: number;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
  key?: string;
  sortable: boolean;
  filter: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "id",
    numeric: true,
    disablePadding: false,
    label: "",
    sortable: false,
    filter: false,
  },
  {
    id: "descrizioneUso",
    numeric: false,
    disablePadding: false,
    label: "Descrizione Uso",
    sortable: true,
    filter: true,
  },
  {
    id: "minPartecipanti",
    numeric: false,
    disablePadding: false,
    label: "Min Partecipanti",
    sortable: true,
    filter: true,
  },
  {
    id: "maxPartecipanti",
    numeric: false,
    disablePadding: false,
    label: "Max Partecipanti",
    sortable: true,
    filter: true,
  },
  {
    id: "deleted",
    numeric: false,
    disablePadding: false,
    label: "Deleted",
    sortable: true,
    filter: false,
  },
  {
    id: "sigla",
    numeric: false,
    disablePadding: false,
    label: "Sigla",
    sortable: true,
    filter: true,
  },
  {
    id: "id",
    numeric: true,
    disablePadding: false,
    label: "",
    sortable: false,
    filter: false,
    key: "id2",
  },
];

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  onFilter: (event: any, property: keyof Data, filter: string | number) => void;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort, onFilter } = props;
  const createSortHandler = (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };
  const createFilterHandler = (property: keyof Data) => (event: any) => {
    onFilter(event, property, event.target.value);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index: number) => (
          <TableCell
            key={headCell.key ? headCell.key : headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sortable && (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.key ? headCell.key : headCell.id}>
            {headCell.filter && (
              <TextField label="" variant="standard" onChange={createFilterHandler(headCell.id)} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function Row(props: { row: Data; edit: (id: number) => void; delete2: (id: number) => void }) {
  const { row, edit, delete2 } = props;

  return (
    <>
      <TableRow hover tabIndex={-1}>
        <TableCell sx={{ whiteSpace: "nowrap" }}>
          <IconButton aria-label="edit" onClick={() => edit(row.id)} sx={{ p: 0 }}>
            <EditIcon />
          </IconButton>
        </TableCell>
        <TableCell>{row.descrizioneUso}</TableCell>
        <TableCell>{row.minPartecipanti}</TableCell>
        <TableCell>{row.maxPartecipanti}</TableCell>
        <TableCell>{row.deleted ? "Si" : "No"}</TableCell>
        <TableCell>{row.sigla}</TableCell>
        <TableCell sx={{ whiteSpace: "nowrap" }}>
          <IconButton aria-label="edit" sx={{ p: 0 }} onClick={() => delete2(row.id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
}

export function TipologieUso() {
  const { isLoading, data } = useQuery<unknown, AxiosError, { tipologieUso: Data[] }>(
    ["tipologie-uso/findAll"],
    () => axios.get(API_URL + "tipologie-uso/findAll").then((res) => res.data)
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [open2, setOpen2] = useState(false);
  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const [open3, setOpen3] = useState(false);
  const handleClickOpen3 = () => {
    setOpen3(true);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };

  const [id, setId] = useState(0);
  const [id2, setId2] = useState(0);

  const rows = data?.tipologieUso ?? [];

  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof Data>("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState({});
  const dense = oraPrenotaStore((state) => state.tabelleCompatte);

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof Data) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleFilterRequest = (
    event: React.MouseEvent<unknown>,
    property: keyof Data,
    filter: string | number
  ) => {
    setFilters({
      ...filters,
      [property]: filter,
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const edit = (id: number) => {
    setId(id);
    handleClickOpen2();
  };

  const delete2 = (id: number) => {
    setId2(id);
    handleClickOpen3();
  };

  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => {
    setTitle("Gestione tipologie d'uso");
  }, [setTitle]);

  if (isLoading) return <></>;

  return (
    <Box sx={{ width: "100%" }}>
      <Button
        color="secondary"
        onClick={handleClickOpen}
        sx={{ mb: 2 }}
        startIcon={<AddCircleOutlineIcon />}
      >
        Aggiungi tipologia uso
      </Button>

      <TableContainer>
        <Table aria-labelledby="tableTitle" size={dense ? "small" : "medium"}>
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
            onFilter={handleFilterRequest}
          />
          <TableBody classes={{ root: "table-body" }}>
            {stableSort(rows, getComparator(order, orderBy), filters)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return <Row row={row} key={row.id} edit={edit} delete2={delete2} />;
              })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 53) * emptyRows,
                }}
              ></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <Dialog open={open} onClose={handleClose} fullScreen={fullScreen}>
        <TipologiaUso closeDialog={handleClose} />
      </Dialog>
      <Dialog open={open2} onClose={handleClose2} fullScreen={fullScreen}>
        <TipologiaUso id={id} closeDialog={handleClose2} />
      </Dialog>

      <Dialog open={open3} onClose={handleClose3} fullScreen={fullScreen}>
        <DeleteTipologiaUso id={id2} closeDialog={handleClose3} />
      </Dialog>
    </Box>
  );
}
